/* eslint-disable react/prop-types */
import React from 'react';
import Style from './index.less';
import { shouldShowNewFeatureIntroRedPoint } from '../../../../utils/whats-new';
import { TOOLBAR_DOT_NORMAL_ICON } from '../../../editor/src/img/pageIndex';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';

/** 通用菜单默认item */
export default function OptionMenuItem(props) {
    const title = props.title || props.content || '';
    const pointId = props.id === ActionType.INSERT_IFRAME_ITEM && props.aid
        ? `${props.id}-${props.aid[props.aid.length - 1]}`
        : props.id;
    const canShowRedPoint = shouldShowNewFeatureIntroRedPoint(pointId);
    const { extraAddonId, id } = props;
    return (
        <React.Fragment>
            {title ? <span className="option-menu-item-text-e2e-locate">{title}</span> : null}
            {canShowRedPoint ? <img className={Style['new-dot']} src={TOOLBAR_DOT_NORMAL_ICON} /> : null}
            {id.indexOf(extraAddonId) > 0
            && <div className={Style['tag-same-wrapper']}>
                <div className={Style['tag-same-text']}>{i18n.t('同款')}</div>
            </div>}
        </React.Fragment>
    );
}
